import useHasPermission from "core/features/permissions/hooks/useHasPermission";
import React from "react";

interface WithPermissionProps {
  permissions: string[];
  children: React.ReactNode;
}
function WithPermission({ permissions, children }: WithPermissionProps) {
  const hasPermission = useHasPermission(permissions);

  if (!hasPermission) {
    return null;
  }

  return <>{children}</>;
}

export default WithPermission;
